// Wishlist customization page

// Email Modal
var modal = document.getElementById("email-share-modal");
var btn = document.getElementById("share-wishlist-email");
var mobBtn = document.getElementById("mobile-share-wishlist-email");
var span = document.getElementsByClassName("close-modal")[0];

// When the user clicks on the button, open the modal
btn.onclick = function() {
  modal.style.display = "block";
}

mobBtn.onclick = function() {
  modal.style.display = "block";
}
// When the user clicks on <span> (x), close the modal
span.onclick = function() {
  modal.style.display = "none";
}
// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}

function sharePinterest(){

  var fromName = "{{ customer.first_name }}";

  _swat.generateSharedListURL(
    null,
    function(data, sharedListId) {  
      var shareUrl = data;
      // console.log(shareUrl);
        window._swat.shareListSocial(
          null,
          fromName,
          "https://pinterest.com/pin/create/link/?url=" + shareUrl + "&t={{note}}",
          "pinterest",
          function(data) { 
            // console.log(data, "the data") 
          }
        ); // will open facebook share dialog
    },     // returns the generated url
    function(data) { 
      // console.log(data); 
    }
  );

}

function shareTwitter(){

  var fromName = "{{ customer.first_name }}";

  _swat.generateSharedListURL(
    null,
    function(data, sharedListId) {  
      var shareUrl = data;
      // console.log(shareUrl);
        window._swat.shareListSocial(
          null,
          fromName,
          "https://twitter.com/intent/tweet?text=" + shareUrl + "&t={{note}}",
          "twitter",
          function(data) { 
            // console.log(data, "the data") 
          }
        ); // will open facebook share dialog
    },     // returns the generated url
    function(data) { 
      // console.log(data); 
    }
  );

}
  
function shareMessenger(){

  var fromName = "{{ customer.first_name }}";

  _swat.generateSharedListURL(
    null,
    function(data, sharedListId) {  
      var shareUrl = data;
      // console.log(shareUrl);
        window._swat.shareListSocial(
          null,
          fromName,
          "fb-messenger://share/?link=" + shareUrl + "&t={{note}}",
          "facebook messenger",
          function(data) { 
            // console.log(data, "the data") 
          }
        ); // will open facebook share dialog
    },     // returns the generated url
    function(data) { 
      // console.log(data); 
    }
  );

}

function shareFacebook(){

  var fromName = "{{ customer.first_name }}";

  _swat.generateSharedListURL(
    null,
    function(data, sharedListId) {  
      var shareUrl = data;
      console.log(shareUrl);
        window._swat.shareListSocial(
          null,
          fromName,
          "https://www.facebook.com/sharer.php?u=" + shareUrl + "&t={{note}}",
          "facebook",
          function(data) { 
            console.log(data, "the data") 
          }
        ); // will open facebook share dialog
    },     // returns the generated url
    function(data) { 
      console.log(data); 
    }
  );


}

  
function emailShare(){

  var from = document.getElementById('swym-name').value,
      recipient = document.getElementById('swym-email').value,
      note = document.getElementById('swym-note').value,
      modalContent = document.getElementById("modal-content");

  window._swat.sendListViaEmail(
    {
      toEmailId: recipient,
      fromName: from,
      note: note,
//        lid: listId, // null when multiple list is not enabled
     cprops: {}, // custom props for the share, future usage
    },
    function(r) {
      console.log('Email sent!');
      modalContent.innerHTML = 'Your List has been shared!';
    },
    function(r) {
      console.log('Email failed!');
    }
  );
}

function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

function validate() {
  const $result = $("#result");
  const email = $("#swym-email").val();
  $result.text("");

  if (validateEmail(email)) {
  //submit
  $result.css("display", "none");
  } else {
    $result.text("Please enter a valid email address");
    $result.css("display", "block");
    $result.css("color", "red");
  }
  return false;
}

$("#validate").on("click", validate);

function createUrl(){
  
  var copyContent = document.getElementById("copy-link");
  window._swat.generateSharedListURL(
    null,
    function(data, sharedListId) { 
      console.log(data); 
      copyContent.setAttribute('value', data);
    },     // returns the generated url
    function(data) { console.log(data); }
  );
}
window.addEventListener('load', (event) => {
createUrl();
});

function copyToClipboard() {

  var copyText = document.getElementById("copy-link");
  copyText.select();
  copyText.setSelectionRange(0, 99999);
  document.execCommand("copy");

  var tooltip = $("#clipboard-tooltip");
  tooltip.css('opacity', '1');
  setTimeout(function() {
    tooltip.css('opacity', '0');
  }, 1000);

  var mtooltip = $("#mobile-clipboard-tooltip");
  mtooltip.css('opacity', '1');
  setTimeout(function() {
    mtooltip.css('opacity', '0');
  }, 1000);
  tooltip.text("Copied!");

}

function outFunc() {
//   var tooltip = $("#clipboard-tooltip");
//   tooltip.text("");
}

